// extracted by mini-css-extract-plugin
module.exports = {"UtilityBoxItem":"utility-box-item-v2_UtilityBoxItem__A8JB7","childWrapper":"utility-box-item-v2_childWrapper__OsbaX","icon":"utility-box-item-v2_icon__Q55qR"};